import { Typography } from '@mui/material';
import type { GridValidRowModel } from '@mui/x-data-grid-premium';
import { RiCloseLine, RiSearchLine } from '@remixicon/react';
import { AgButton } from 'src/components/ui';
import { NO_RESULTS_GUIDANCE } from '../a11y';
import type { GridColObj } from '../DataGrid';
import type { PagedGridRowsState } from './useGridRows';

type Props<Row extends GridValidRowModel> = {
  enhancedGridState: PagedGridRowsState;
  columns: GridColObj<Row>;
  noResultsLabel?: string;
};

export default function NoRowsOverlay<Row extends GridValidRowModel>({
  enhancedGridState,
  columns,
  noResultsLabel,
}: Props<Row>) {
  const hasFilters =
    enhancedGridState.gridFilters?.length > 0 &&
    enhancedGridState.gridFilters.some((f) => columns[f.field]?.customFilterType !== 'locked');
  const hasSearch = (enhancedGridState.searchText?.length ?? 0) > 0;

  const clearFilters = () => {
    const lockedFilters = enhancedGridState.gridFilters.filter((f) => {
      const column = columns[f.field];
      return column?.customFilterType === 'locked';
    });
    enhancedGridState.updateFilters(lockedFilters);
    enhancedGridState.setSearch('');
  };

  return (
    <div className="flex flex-col items-center justify-center w-full" style={{ minHeight: '320px', gap: '20px' }}>
      <RiSearchLine size={32} className="text-brand-5" />
      <Typography>{noResultsLabel || 'No matching results.'}</Typography>
      {(hasFilters || hasSearch) && (
        <>
          <Typography>{NO_RESULTS_GUIDANCE}</Typography>
          <AgButton variant="destructive-white" onPress={() => clearFilters()}>
            <RiCloseLine size={20} />
            Clear all filters
          </AgButton>
        </>
      )}
    </div>
  );
}
